// extracted by mini-css-extract-plugin
export default {"dashboard":"TrendingTasksPage_dashboard__Dreee"};